import React from "react";
import {NullOrEmpty} from "modules/types";
import {useSelector} from "react-redux";
import {getSquadById} from "modules/selectors";
import {IMAGES_URL} from "modules/constants";

export interface IProps {
	squadId: NullOrEmpty<number>;
}

export const SquadImage: React.FC<IProps> = ({squadId}) => {
	const squad = useSelector(getSquadById)(squadId);
	const imageUrl = `${IMAGES_URL}image/${squad?.logo ?? ""}`;

	if (!squad) {
		return null;
	}

	return <img src={imageUrl} alt={squad.shortName} />;
};
